"use client";

import { useTranslations } from "@zapier/i18n";
import { Spinner, Text } from "@zapier/design-system";

import styles from "./RedirectLoadingOverlay.module.css";

interface Props {
  targetAccountName: string;
}

/**
 * Full-screen overlay shown after a successful cross-account copy while we
 * redirect to the destination folder in the target account. Lives outside the
 * modal so it persists across the brief moment between modal close and
 * `location.href` navigation taking effect.
 */
export function RedirectLoadingOverlay({ targetAccountName }: Props) {
  const t = useTranslations("redirect-loading-overlay");
  return (
    <div className={styles.overlay} role="status" aria-live="polite">
      <div className={styles.indicator}>
        <div className={styles.content}>
          <Spinner size="small" aria-label="Redirecting" />
          <Text type="SmallPrint1">
            {t("message", { accountName: targetAccountName })}
          </Text>
        </div>
      </div>
    </div>
  );
}
